export default __webpack_public_path__ + "static/media/f6.e49b5848.jpg";